/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress } from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import {
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSONTyped,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON,
} from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';
import type { ExecRiskForeignAddress } from './ExecRiskForeignAddress';
import {
    ExecRiskForeignAddressFromJSON,
    ExecRiskForeignAddressFromJSONTyped,
    ExecRiskForeignAddressToJSON,
} from './ExecRiskForeignAddress';

/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
 */
export interface ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership {
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    business_name?: ExecRiskBusinessName;
    /**
     * 
     * @type {ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    us_address?: ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress;
    /**
     * 
     * @type {ExecRiskForeignAddress}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    foreign_address?: ExecRiskForeignAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    ein?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    primary_activities_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    legal_domicile_state_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    legal_domicile_foreign_country_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    predominate_income_desc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    all_partners_c_3_s_ind?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    share_of_total_income_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    share_of_eoy_assets_amt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    disproportionate_allocations_ind?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    ubi_code_v_amt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    general_or_managing_partner_ind?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership
     */
    ownership_pct?: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnershipFromJSON(json: any): ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership {
    return ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnershipFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'business_name': !exists(json, 'business_name') ? undefined : ExecRiskBusinessNameFromJSON(json['business_name']),
        'us_address': !exists(json, 'us_address') ? undefined : ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON(json['us_address']),
        'foreign_address': !exists(json, 'foreign_address') ? undefined : ExecRiskForeignAddressFromJSON(json['foreign_address']),
        'ein': !exists(json, 'ein') ? undefined : json['ein'],
        'primary_activities_txt': !exists(json, 'primary_activities_txt') ? undefined : json['primary_activities_txt'],
        'legal_domicile_state_cd': !exists(json, 'legal_domicile_state_cd') ? undefined : json['legal_domicile_state_cd'],
        'legal_domicile_foreign_country_cd': !exists(json, 'legal_domicile_foreign_country_cd') ? undefined : json['legal_domicile_foreign_country_cd'],
        'predominate_income_desc': !exists(json, 'predominate_income_desc') ? undefined : json['predominate_income_desc'],
        'all_partners_c_3_s_ind': !exists(json, 'all_partners_c_3_s_ind') ? undefined : json['all_partners_c_3_s_ind'],
        'share_of_total_income_amt': !exists(json, 'share_of_total_income_amt') ? undefined : json['share_of_total_income_amt'],
        'share_of_eoy_assets_amt': !exists(json, 'share_of_eoy_assets_amt') ? undefined : json['share_of_eoy_assets_amt'],
        'disproportionate_allocations_ind': !exists(json, 'disproportionate_allocations_ind') ? undefined : json['disproportionate_allocations_ind'],
        'ubi_code_v_amt': !exists(json, 'ubi_code_v_amt') ? undefined : json['ubi_code_v_amt'],
        'general_or_managing_partner_ind': !exists(json, 'general_or_managing_partner_ind') ? undefined : json['general_or_managing_partner_ind'],
        'ownership_pct': !exists(json, 'ownership_pct') ? undefined : json['ownership_pct'],
    };
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnershipToJSON(value?: ExecRiskApiAppCoreModelsScansForm990ScheduleRUnrelatedOrgTxblPartnership | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'business_name': ExecRiskBusinessNameToJSON(value.business_name),
        'us_address': ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON(value.us_address),
        'foreign_address': ExecRiskForeignAddressToJSON(value.foreign_address),
        'ein': value.ein,
        'primary_activities_txt': value.primary_activities_txt,
        'legal_domicile_state_cd': value.legal_domicile_state_cd,
        'legal_domicile_foreign_country_cd': value.legal_domicile_foreign_country_cd,
        'predominate_income_desc': value.predominate_income_desc,
        'all_partners_c_3_s_ind': value.all_partners_c_3_s_ind,
        'share_of_total_income_amt': value.share_of_total_income_amt,
        'share_of_eoy_assets_amt': value.share_of_eoy_assets_amt,
        'disproportionate_allocations_ind': value.disproportionate_allocations_ind,
        'ubi_code_v_amt': value.ubi_code_v_amt,
        'general_or_managing_partner_ind': value.general_or_managing_partner_ind,
        'ownership_pct': value.ownership_pct,
    };
}

